"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGrid = void 0;
var Utilities_1 = require("../../Utilities");
var ButtonGrid_base_1 = require("./ButtonGrid.base");
var ButtonGrid_styles_1 = require("./ButtonGrid.styles");
exports.ButtonGrid = (0, Utilities_1.styled)(ButtonGrid_base_1.ButtonGridBase, ButtonGrid_styles_1.getStyles);
exports.ButtonGrid.displayName = 'ButtonGrid';
//# sourceMappingURL=ButtonGrid.js.map